<template>
  <div class="recharge-page">
    <!-- 主要内容区域 -->
    <div class="recharge-container">
      <!-- 标题区域 - 在卡片外面 -->
      <div class="page-header">
        <img src="@/img/recharge/oumi_coin.webp" alt="Oumiコイン" class="coin-icon">
        <h1 class="page-title">Oumi チャージ</h1>
      </div>
      
      <!-- 充值卡片 -->
      <div class="recharge-card">
        <!-- 用户ID输入 -->
        <div class="input-section">
          <label class="input-label">ユーザーID</label>
          <input 
            type="text" 
            v-model="user_id" 
            class="user-input" 
            @blur="saveUid" 
            @keyup="checkUid"
            placeholder="ユーザーIDを入力…" 
          />
          
          <!-- 用户信息显示 -->
          <div v-if="user" class="user-info">
            <img :src="user.avatar" class="user-avatar">
            <div class="user-details">
              <div class="user-name">{{ user.nickName }}</div>
              <div class="user-uid">UID: {{ user.userId }}</div>
            </div>
          </div>
        </div>

        <!-- 金币选择区域 -->
        <div class="amount-section">
          <label class="section-label">チャージ金額を選択</label>
          <div class="coin-options">
            <div 
              v-for="item in recharge_list" 
              :key="item.id"
              class="coin-option"
              :class="{ active: item.id === select_recharge_id }"
              @click="priceChangeHandle(item)"
            >
              <div class="coin-amount">
                <img src="@/img/recharge/oumi_coin.webp" alt="コイン" class="coin-icon-small">
                {{ item.coin }}
              </div>
            </div>
          </div>
        </div>

        <!-- 支付按钮 -->
        <div class="payment-section">
          <button
            v-if="isPhilippineCoinUser"
            type="button"
            class="payment-button ph-coin-top-up-button"
            :disabled="!canSubmitPhilippineCoins || !!clickPayItem"
            @click="philippineCoinTopUpClick"
          ><div class="button-content"><span class="payment-text">{{ clickPayItem ? messages.pleaseWait : 'チャージする' }}</span></div></button>
          <!-- <button 
              class="payment-button"
              @click="stripePayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'STRIPE' }">
                <div v-if="clickPayItem === 'STRIPE'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" alt="Stripe" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'STRIPE' ? '決済中…' : 'Stripe決済' }}</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button> -->

            <!-- <button 
              class="payment-button"
              @click="airwallexPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content">
                <img src="@/img/ic_airwallex.svg" alt="Airwallex" class="payment-icon">
                <span class="payment-text">Airwallex</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button> -->
          <!-- 遍历所有支持的支付方式 -->
          <div v-for="payType in (isPhilippineCoinUser ? [] : supportedPayTypes)" :key="payType" class="payment-method">
            <!-- Stripe 支付 -->
            <button 
              v-if="(payType === 'STRIPE' || payType === 'DIANDIAN') && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="stripePayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'STRIPE' }">
                <div v-if="clickPayItem === 'STRIPE'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" alt="Stripe" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'STRIPE' ? '決済中…' : 'Stripe決済' }}</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button>

            <!-- PayerMax 支付 -->
            <button 
              v-else-if="payType === 'PAYERMAX' && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="payermaxClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'PAYERMAX' }">
                <div v-if="clickPayItem === 'PAYERMAX'" class="loading-spinner"></div>
                <img src="@/img/ic_payermax.svg" alt="PayerMax" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'PAYERMAX' ? '決済中…' : 'PayerMax' }}</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button>

            <!-- PayPal 支付 -->
            <button 
              v-else-if="payType === 'PAYPAL' && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="customPaypalClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'PAYPAL' }">
                <div v-if="clickPayItem === 'PAYPAL'" class="loading-spinner"></div>
                <img src="@/img/ic_paypal.svg" alt="PayPal" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'PAYPAL' ? '決済中…' : 'PayPal' }}</span>
                <span class="payment-price">{{ formatItemYen(paypal_product_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button>

            <!-- DIANDIAN 支付 -->
            <!-- <button 
              v-else-if="payType === 'DIANDIAN'"
              class="payment-button"
              @click="diandianPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'DIANDIAN' }">
                <div v-if="clickPayItem === 'DIANDIAN'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" alt="Diandian" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'DIANDIAN' ? "Paying..." : "Diandian Pay" }}</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button> -->

            <!-- HAIPAY_USDT 支付 -->
            <!-- <button 
              v-else-if="payType === 'HAIPAY_USDT'"
              class="payment-button"
              @click="haipayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'HAIPAY_USDT' }">
                <div v-if="clickPayItem === 'HAIPAY_USDT'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" alt="HaiPay" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'HAIPAY_USDT' ? "Paying..." : "HaiPay USDT" }}</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button> -->
          </div>
          <button 
              v-if="isPaymentMethodAvailable('AIRWALLEX')"
              class="payment-button"
              @click="airwallexPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content">
                <img src="@/img/ic_airwallex.svg" alt="Airwallex" class="payment-icon">
                <span class="payment-text">Airwallex</span>
                <span class="payment-price">{{ formatItemYen(select_recharge_item, 20) }}</span>
                <span class="original-price">({{ formatOriginalYen(select_recharge_item, 32) }})</span>
              </div>
            </button>
        </div>
      </div>
    </div>

    <!-- 加载遮罩 -->
    <div class="loading-overlay" v-if="loading">
      <div class="loader"></div>
      <span>コインを配布しています…</span>
    </div>
  </div>
</template>

<script setup>
import router from '#/router'
import { computed, onMounted, ref } from 'vue'
import { getChargeProducts, getPhilippineCoinProducts, createOrder, verifyReceipt, getUser, getChargeProductIten } from "#/api/index.js"
import { toastSuccess, toastError } from "#/utils/toast"
import { loadScript } from "@paypal/paypal-js"
import * as Airwallex from '@airwallex/components-sdk'
import { isPhilippineRechargeUser, filterCoinProducts, buildPhilippineCoinOrder, coinPaymentUrl } from '#/utils/coinRecharge.js'


const loading = ref(false)
const select_recharge_id = ref(1)
const select_recharge_item = ref()
const paypal_product_item = ref()
const recharge_list = ref([])
const supportedPayTypes = ref([])
const user = ref(null)
const user_id = ref('')
const clickPayItem = ref(null)
const catalogUid = ref('')
const validatedUid = ref('')
const productsLoading = ref(false)
let productGeneration = 0
let userGeneration = 0
const isPhilippineCoinUser = computed(() => isPhilippineRechargeUser(user_id.value))
const canSubmitPhilippineCoins = computed(() => isPhilippineCoinUser.value && !!user.value
  && validatedUid.value === `${user_id.value}` && catalogUid.value === `${user_id.value}`
  && !productsLoading.value && !!select_recharge_item.value?.supportedPayType)
const isTest = import.meta.env.VITE_NODE_ENV !== 'production'
const JPY_RATE = 165
const messages = {
  enterUserToRecharge: 'チャージ対象のユーザーを入力してください',
  pleaseWait: 'しばらくお待ちください…',
  topUpFailed: 'チャージに失敗しました',
  createOrderFailed: '注文の作成に失敗しました',
  topUpSuccessful: 'チャージが完了しました',
  paypalOrderCreationFailed: 'PayPal注文の作成に失敗しました',
  paymentVerificationFailed: '決済の検証に失敗しました',
}

function getNumericPrice(value) {
  const price = parseFloat(String(value ?? '').replace(/[^\d.]/g, ''))
  return Number.isFinite(price) ? price : null
}

function getItemUsd(item, fallbackUsd = 20) {
  if (!item) return fallbackUsd
  return getNumericPrice(item.localPrice) ?? getNumericPrice(item.cent) ?? (item.coin / 50)
}

function formatYen(usd) {
  return '¥' + Math.round(Number(usd || 0) * JPY_RATE).toLocaleString('ja-JP')
}

function formatItemYen(item, fallbackUsd = 20) {
  return formatYen(getItemUsd(item, fallbackUsd))
}

function formatOriginalYen(item, fallbackUsd = 32) {
  return formatYen(item ? item.coin / 50 : fallbackUsd)
}

var chargeUid = 0
let orderMap = {}

// 判断支付方式是否可用
function isPaymentMethodAvailable(payType) {
  if (!select_recharge_item.value) return false
  if (isPhilippineCoinUser.value || productsLoading.value || catalogUid.value !== `${user_id.value ?? ''}`) return false
  
  // 获取实际美元价格
  const priceInDollars = select_recharge_item.value.coin / 50
  
  // Airwallex 需要50美元起步
  if (payType === 'AIRWALLEX') {
    return priceInDollars >= 50
  }
  
  // 其他支付方式20美元起步
  return priceInDollars >= 20
}

async function airwallexPayClick() {
  if (!user.value) {
    toastError(messages.enterUserToRecharge)
    return 0;
  }

  if (clickPayItem.value) {
    toastError(messages.pleaseWait)
    return;
  }

  try {
    clickPayItem.value = "AIRWALLEX"

    var requestBody = {
      product_id: select_recharge_id.value,
      pay_item_type: "AIRWALLEX",
      user_id: user.value.userId,
      v2: true,
      extra: JSON.stringify({
        return_url: window.location.origin + '/ja/recharge'
      })
    }
    loading.value = true

    const rsp = await createOrder(requestBody)
    
    var airwallexInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
    console.log(airwallexInfo)
    const { payments } = await Airwallex.init({
        env: isTest ? 'demo' : 'prod', // Setup which Airwallex env('staging' | 'demo' | 'prod') to integrate with
        enabledElements: ['payments']})
    
    payments.redirectToCheckout({
      env: isTest ? 'demo' : 'prod',
      mode: 'payment',
      currency: 'USD', 
      intent_id: airwallexInfo.intentId,
      client_secret: airwallexInfo.client_secret,
      successUrl: window.location.origin + `/ja/recharge?uid=${user.value.userId}&airwallex=1&orderId=${rsp.data.orderId}`,
      failUrl: window.location.origin + '/ja/recharge?airwallex=1',
      appearance: {
            mode: 'dark', // choose between 'dark' and 'light'
            variables: {
              colorBrand: '#612FFF',
            },
          }
    })

    loading.value = false
    clickPayItem.value = null

  } catch (error) {
    toastError(messages.topUpFailed)
  } finally {
    loading.value = false
    clickPayItem.value = null
  }
}

function priceChangeHandle(item) {
  select_recharge_id.value = item.id
  select_recharge_item.value = item
  if (!isPhilippineCoinUser.value) loadPaypalProductItem()
}

async function loadPaypalProductItem() {
  if (isPhilippineCoinUser.value) return
  const uid = `${user_id.value ?? ''}`
  const id = select_recharge_id.value
  let res = await getChargeProductIten(id, "PAYPAL", uid)
  if (res && res.success && uid === `${user_id.value ?? ''}` && id === select_recharge_id.value) {
    paypal_product_item.value = res.data
  }
}

async function getProductList() {
  const current = ++productGeneration
  const uid = `${user_id.value ?? ''}`
  const philippine = isPhilippineRechargeUser(uid)
  productsLoading.value = true
  catalogUid.value = ''
  recharge_list.value = []
  supportedPayTypes.value = []
  select_recharge_item.value = null
  paypal_product_item.value = null
  try {
    const res = await (philippine ? getPhilippineCoinProducts(uid) : getChargeProducts(uid))
    if (current !== productGeneration || uid !== `${user_id.value ?? ''}`) return
    if (!res?.success) throw new Error(res?.message || messages.topUpFailed)
    recharge_list.value = filterCoinProducts(res.data?.product, philippine)
    supportedPayTypes.value = philippine ? [] : (res.data?.supportedPayTypes ?? [])
    catalogUid.value = uid
    select_recharge_item.value = recharge_list.value[0] ?? null
    if (select_recharge_item.value) {
      select_recharge_id.value = select_recharge_item.value.id
      if (!philippine) loadPaypalProductItem()
    }
  } catch (error) {
    if (current === productGeneration) toastError(error?.message || messages.topUpFailed)
  } finally {
    if (current === productGeneration) productsLoading.value = false
  }
}

async function philippineCoinTopUpClick() {
  if (!canSubmitPhilippineCoins.value || clickPayItem.value) return
  clickPayItem.value = select_recharge_item.value.supportedPayType
  loading.value = true
  try {
    const rsp = await createOrder(buildPhilippineCoinOrder(select_recharge_item.value, user.value.userId, `${window.location.origin}/recharge`))
    const url = rsp?.success && coinPaymentUrl(rsp.data)
    if (!url) throw new Error(rsp?.message || messages.createOrderFailed)
    window.location.assign(url)
  } catch (error) {
    toastError(error?.response?.data?.message ?? error?.message ?? messages.topUpFailed)
  } finally {
    clickPayItem.value = null
    loading.value = false
  }
}

function checkUid(e) {
  let str = e.target.value;
  if (str[0] == 0) {
    user_id.value = str.substr(1);
  }
  user_id.value = user_id.value + '';
  user_id.value = user_id.value.replace(/[^\d]/g, '')
  if (`${user_id.value}` !== validatedUid.value) user.value = null
}

async function saveUid(e) {
  user_id.value = `${e.target.value ?? ''}`.replace(/[^\d]/g, '')
  await Promise.all([getinfoByUid(user_id.value), getProductList()])
}

async function getinfoByUid(uid) {
  const current = ++userGeneration
  validatedUid.value = ''
  user.value = null
  chargeUid = uid
  if (chargeUid) {
    try {
      const res = await getUser({ user_id: uid })
      if (current !== userGeneration || `${uid}` !== `${user_id.value}`) return
      if (!res?.success) throw new Error(res?.message || messages.enterUserToRecharge)
      user.value = res.data
      validatedUid.value = `${uid}`
    } catch (error) {
      if (current === userGeneration) toastError(error?.message || messages.enterUserToRecharge)
    }
  }
}

async function stripePayClick() {
  if (!user.value) {
    toastError(messages.enterUserToRecharge)
    return 0;
  }

  if (clickPayItem.value) {
    toastError(messages.pleaseWait)
    return;
  }

  try {
    clickPayItem.value = "STRIPE"

    var requestBody = {
      product_id: select_recharge_id.value,
      pay_item_type: "STRIPE",
      user_id: user.value.userId,
      v2: true,
      extra: JSON.stringify({
        return_url: window.location.origin + '/ja/recharge'
      })
    }
    loading.value = true

    const rsp = await createOrder(requestBody)

    loading.value = false
    clickPayItem.value = null

    sessionStorage.setItem('__stp.od', JSON.stringify(rsp.data))
    sessionStorage.setItem('uid', user.value.userId)

    var stripeInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)

    router.push({ name: 'stripe', state: { stripeInfo } })
  } catch (error) {
    toastError(messages.topUpFailed)
  } finally {
    loading.value = false
    clickPayItem.value = null
  }
}

async function checkStripeSession(sessionId) {
  try {
    let stripeOrder = JSON.parse(sessionStorage.getItem('__stp.od'))
    let uid = sessionStorage.getItem('uid')
    if (!stripeOrder || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: stripeOrder.orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        session_id: sessionId,
        packageName: "yay.chat.app"
      })
    }

    loading.value = true

    const rsp = await verifyReceipt(requestBody);

    loading.value = false
    sessionStorage.removeItem('__stp.od')
    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(messages.topUpSuccessful)
      window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
    } else {
      toastError(rsp.message ?? messages.topUpFailed)
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

// PayerMax 支付
async function payermaxClick() {
  if (!user.value) {
    toastError(messages.enterUserToRecharge)
    return 0;
  }

  if (clickPayItem.value) {
    toastError(messages.pleaseWait)
    return;
  }

  clickPayItem.value = "PAYERMAX"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "PAYERMAX",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      front_callback_url: window.location.origin + '/ja/recharge'
    })
  }

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)
    
    clickPayItem.value = null
    loading.value = false

    if (rsp.success) {
      var payermaxInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      window.location.href = payermaxInfo.redirectUrl
    } else {
      toastError(rsp.message ?? messages.createOrderFailed)
    }
  } catch (e) {
    toastError(e)
  } finally {
    loading.value = false
    clickPayItem.value = null
  }
}

// DIANDIAN 支付
async function diandianPayClick() {
  if (!user.value) {
    toastError(messages.enterUserToRecharge)
    return 0;
  }

  if (clickPayItem.value) {
    toastError(messages.pleaseWait)
    return;
  }

  clickPayItem.value = "DIANDIAN"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "DIANDIAN",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      callback_url: window.location.origin + '/ja/recharge'
    })
  }

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)
    
    clickPayItem.value = null
    loading.value = false

    if (rsp.success) {
      var payInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      window.location.href = payInfo.payLink
    } else {
      toastError(rsp.message ?? messages.createOrderFailed)
    }
  } catch (e) {
    toastError(e)
  } finally {
    loading.value = false
    clickPayItem.value = null
  }
}

// PayPal 支付
async function customPaypalClick() {
  const paypalOrderInfo = await createPaypalOrder()
  if (paypalOrderInfo) {
    const link = paypalOrderInfo.links.find((item) => item.rel == 'payer-action')
    if (link) {
      window.location.href = link.href
    }
  }
}

async function createPaypalOrder() {
  try {
    if (!user.value) {
      toastError(messages.enterUserToRecharge)
      return null;
    }

    var requestBody = {
      product_id: select_recharge_id.value,
      pay_item_type: "PAYPAL",
      user_id: user.value.userId,
      v2: true,
      extra: JSON.stringify({
        return_url: window.location.origin + '/ja/recharge',
        cancel_url: window.location.origin + '/ja/recharge'
      })
    }

    loading.value = true
    const orderRsp = await createOrder(requestBody)
    loading.value = false

    if (orderRsp.success) {
      let bizOrderId = orderRsp.data.orderId;
      var paypalOrderInfo = JSON.parse(orderRsp.data.payInfo.payInfoExtra.payExtra)
      orderMap[paypalOrderInfo.id] = orderRsp.data.orderId
      return paypalOrderInfo;
    } else {
      toastError(orderRsp.message ?? messages.createOrderFailed)
      return null;
    }
  } catch (error) {
    console.error(error);
    toastError(messages.paypalOrderCreationFailed)
    return null;
  } finally {
    loading.value = false
  }
}

// 验证 PayerMax 支付
async function checkPayermax(uid, orderId, tradeNo) {
  try {
    if (!tradeNo || !orderId || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        outTradeNo: tradeNo,
        packageName: "yay.chat.app"
      })
    }

    loading.value = true
    const rsp = await verifyReceipt(requestBody);
    loading.value = false

    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(messages.topUpSuccessful)
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(rsp.message ?? messages.topUpFailed)
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

// 验证 PayPal 支付
async function checkPaypal(yayOrderId, uid, paypalOid) {
  try {
    var requestBody = {
      order_id: yayOrderId,
      user_id: uid,
      extra_json: JSON.stringify({
        paypalOrderId: paypalOid,
        packageName: "yay.chat.app"
      })
    }

    loading.value = true
    const rsp = await verifyReceipt(requestBody);
    loading.value = false

    if (rsp.success) {
      toastSuccess(messages.topUpSuccessful)
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(messages.topUpFailed)
    }
  } catch (error) {
    console.error(error);
    toastError(messages.paymentVerificationFailed)
  } finally {
    loading.value = false
  }
}

// 验证 DIANDIAN 支付
async function checkDiandianPay(uid, orderId, ddid) {
  try {
    if (!ddid || !orderId || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        diandianId: ddid,
        packageName: "yay.chat.app"
      })
    }

    loading.value = true
    const rsp = await verifyReceipt(requestBody);
    loading.value = false

    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(messages.topUpSuccessful)
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(rsp.message ?? messages.topUpFailed)
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

// 验证 Airwallex 支付
async function checkAirwallexPay(uid, orderId, intentId) {
  try {
    if (!intentId || !orderId || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        id: intentId,
        packageName: "yay.chat.app"
      })
    }

    loading.value = true
    const rsp = await verifyReceipt(requestBody);
    loading.value = false

    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(messages.topUpSuccessful)
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(rsp.message ?? messages.topUpFailed)
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

// HAIPAY_USDT 支付
async function haipayClick() {
  if (!user.value) {
    toastError(messages.enterUserToRecharge)
    return 0;
  }

  if (clickPayItem.value) {
    toastError(messages.pleaseWait)
    return;
  }

  clickPayItem.value = "HAIPAY_USDT"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "HAIPAY_USDT",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      callback_url: window.location.origin + '/ja/recharge'
    })
  }

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)
    
    clickPayItem.value = null
    loading.value = false

    if (rsp.success) {
      var haipayInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      window.location.href = haipayInfo.payUrl
    } else {
      toastError(rsp.message ?? messages.createOrderFailed)
    }
  } catch (e) {
    toastError(e)
  } finally {
    loading.value = false
    clickPayItem.value = null
  }
}

onMounted(() => {
  let queryValue = router.currentRoute.value.query
  user_id.value = `${queryValue.uid ?? ''}`.match(/^\d+/)?.[0] || ''
  const initialUid = user_id.value
  getProductList().then((_) => {
    if (initialUid === user_id.value) getinfoByUid(initialUid)
  })
  
  // 检查各种支付回调
  let sessionId = queryValue.session_id
  let isPayerMax = queryValue.payermax == 1
  let isPaypal = queryValue.paypal == 1
  let isDiandianPay = queryValue.diandianpay == 1
  let isAirwallex = queryValue.airwallex == 1
  
  if (sessionId) {
    let uid = sessionStorage.getItem('uid')
    user_id.value = uid
    loading.value = true
    checkStripeSession(sessionId)
  } else if (isPayerMax) {
    const status = queryValue.status
    if (status && status.toUpperCase() == 'SUCCESS') {
      user_id.value = queryValue.uid
      let orderId = queryValue.orderId
      let tradeNo = queryValue.outTradeNo
      loading.value = true
      checkPayermax(user_id.value, orderId, tradeNo)
    }
  } else if (isPaypal) {
    const state = queryValue.state
    if (queryValue.token && state == 0) {
      checkPaypal(queryValue.yay_oid, queryValue.uid, queryValue.token)
    } else {
      toastError(messages.topUpFailed)
    }
  } else if (isDiandianPay) {
    user_id.value = queryValue.uid
    let orderId = queryValue.orderId
    const ddid = queryValue.ddid
    loading.value = true
    checkDiandianPay(user_id.value, orderId, ddid)
  }else if(isAirwallex) {
    user_id.value = queryValue.uid
    let orderId = queryValue.orderId
    const intentId = queryValue.id
    if(intentId) {
      loading.value = true
      checkAirwallexPay(user_id.value,orderId, intentId)
    } else {
      toastError(messages.topUpFailed)
    }
  }
})
</script>

<style lang='scss' scoped>
.recharge-page {
//   width: 100%;
//   min-height: 100vh;
//   background: linear-gradient(135deg, #000000 0%, #1a1a2e 50%, #16213e 100%);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 20px;
//   box-sizing: border-box;
//   position: relative;


  width: 100%;
    min-height: 100vh;
    background: url('@/img/home/oumi-home-bg.webp') no-repeat center center;
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    background-attachment: scroll;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    justify-content: center;
    align-items: center;
}

.recharge-container {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;

  .coin-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .page-title {
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    font-family: 'Poppins', sans-serif;
  }
}

.recharge-card {
  width: 100%;
  background: rgba(255, 255, 255, 0.08) url('@/img/recharge/recharge_bg.webp') no-repeat top center;
  background-size: cover;
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px 48px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 4px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 0;
  }
  
  > * {
    position: relative;
    z-index: 1;
  }
}

.input-section {
  margin-bottom: 32px;

  .input-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 12px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
  }

  .user-input {
    width: 100%;
    padding: 16px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    font-size: 16px;
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
      outline: none;
      border-color: #FDF652;
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    gap: 12px;

    .user-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      object-fit: cover;
    }

    .user-details {
      .user-name {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 4px;
      }

      .user-uid {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}

.amount-section {
  margin-bottom: 32px;

  .section-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 16px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
  }

  .coin-options {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    justify-items: start;
  }

  .coin-option {
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    padding: 20px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(253, 246, 82, 0.5);
      transform: translateY(-2px);
    }

    &.active {
      background: rgba(253, 246, 82, 0.15);
      border-color: #FDF652;
      box-shadow: 0 0 20px rgba(253, 246, 82, 0.3);
    }

    .coin-amount {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 6px;

      .coin-icon-small {
        width: 20px;
        height: 20px;
      }
    }

    .coin-label {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
    }
  }
}

.payment-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .payment-method {
    width: 100%;
  }

  .payment-button {
    width: 100%;
    background: #ffffff;
    border: none;
    border-radius: 24px;
    padding: 18px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Poppins', sans-serif;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .button-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      position: relative;

      &.loading {
        opacity: 0.7;
      }

      .loading-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid #333333;
        border-top: 2px solid transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      .payment-icon {
        width: 28px;
        height: 28px;
      }

      .payment-text {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }

      .payment-price {
        font-size: 18px;
        font-weight: 700;
        color: #333333;
      }

      .original-price {
        font-size: 14px;
        color: #999999;
        text-decoration: line-through;
        margin-left: 4px;
      }
    }
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #FDF652;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 响应式设计
@media (max-width: 900px) {
  .recharge-page {
    padding: 16px;
  }

  .recharge-container {
    max-width: 100%;
  }

  .page-header {
    .coin-icon {
      width: 32px;
      height: 32px;
    }

    .page-title {
      font-size: 24px;
    }
  }

  .recharge-card {
    padding: 24px 20px;
  }

  .recharge-card .amount-section .coin-options {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px;
  }

  .coin-option {
    width: 100%;
    padding: 16px 8px;

    .coin-amount {
      font-size: 18px;

      .coin-icon-small {
        width: 18px;
        height: 18px;
      }
    }

    .coin-label {
      font-size: 12px;
    }
  }
}

@media (max-width: 480px) {
  .page-header {
    .coin-icon {
      width: 28px;
      height: 28px;
    }

    .page-title {
      font-size: 20px;
    }
  }

  .recharge-card {
    padding: 20px 16px;
  }

  .recharge-card .amount-section .coin-options {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 8px;
  }

  .coin-option {
    width: 100%;
    padding: 12px 6px;

    .coin-amount {
      font-size: 16px;
      gap: 4px;

      .coin-icon-small {
        width: 16px;
        height: 16px;
      }
    }

    .coin-label {
      font-size: 11px;
    }
  }

  .payment-button {
    padding: 14px 20px;

    .button-content {
      gap: 8px;

      .payment-icon {
        width: 24px;
        height: 24px;
      }

      .payment-text {
        font-size: 16px;
      }

      .payment-price {
        font-size: 16px;
      }

      .original-price {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 375px) {
  .recharge-card .amount-section .coin-options {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 8px;
  }
}
</style>
